<!-- Modal RIDE -->
<ng-template #rideModal let-modal="modal">
  <div class="modal-header">
    <h5 class="modal-title">RIDE - Comprobante Electrónico</h5>
    <button type="button" class="close" aria-label="Cerrar" (click)="rideModalRef?.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-0">
    <iframe [src]="rideUrl" style="width: 100%; height: 600px; border: none;"></iframe>
  </div>
</ng-template>

<!-- Modal Ticket -->
<ng-template #ticketModal let-modal="modal">
  <div class="modal-header">
    <h5 class="modal-title">Ticket de Documento</h5>
    <button type="button" class="close" aria-label="Cerrar" (click)="ticketModalRef?.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-0">
    <iframe [src]="ticketUrl" style="width: 100%; height: 600px; border: none;"></iframe>
  </div>
</ng-template>

<!-- Modal Nota Crédito -->
<ng-template #notaCreditoModal let-modal="modal">
  <div class="modal-header">
    <h5 class="modal-title">Crear Nota de Crédito</h5>
    <button type="button" class="close" aria-label="Cerrar" (click)="notaCreditoModalRef?.dismiss()" [disabled]="generandoNC">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    @if (documentoNC) {
      <div class="row g-3">
        <div class="col-12">
          <h6 class="text-muted">Datos del {{ documentoNC.nombre_cliente?.trim() ? 'Cliente Facturado' : 'Paciente' }}</h6>
          <div class="row">
            <div class="col-md-6">
              <small class="text-muted">Nombre</small>
              <p class="fw-bold">{{ documentoNC.nombre_cliente?.trim() ? documentoNC.nombre_cliente : documentoNC.NOM_CLI }}</p>
            </div>
            <div class="col-md-6">
              <small class="text-muted">Cédula</small>
              <p class="fw-bold">{{ documentoNC.cedula_cliente?.trim() ? documentoNC.cedula_cliente : documentoNC.CED_CLI }}</p>
            </div>
          </div>
        </div>

        <div class="col-12">
          <small class="text-muted">Doctor</small>
          <p class="fw-bold">{{ extraerNombreDoctor(documentoNC.OBS_TRAC) }}</p>
        </div>

        <div class="col-12 text-center">
          <small class="text-muted d-block mb-2">Valor a Devolver</small>
          <h3 class="text-success fw-bold">$ {{ documentoNC.TOTPAG_TRAC | number: '1.2-2' }}</h3>
        </div>

        <div class="col-12">
          <label class="form-label fw-bold">Razón de la Modificación *</label>
          <textarea class="form-control" [(ngModel)]="razonModificacion"
                    rows="3" placeholder="Indique el motivo de la nota de crédito"
                    [disabled]="generandoNC"></textarea>
        </div>
      </div>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="notaCreditoModalRef?.dismiss()"
            [disabled]="generandoNC">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="generarNotaCredito()"
            [disabled]="!razonModificacion || generandoNC">
      <span *ngIf="generandoNC" class="spinner-border spinner-border-sm me-2"></span>
      Guarda
    </button>
  </div>
</ng-template>

<!-- breadcrumb -->
<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Facturas Electrónicas</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Transacciones</span>
    </div>
  </div>
</div>

<!-- Filtros -->
<div class="row row-sm mb-3">
  <div class="col-12">
    <div class="card control-panel-card">
      <div class="card-body">
        <div class="row g-4 align-items-end">
          <div class="col-12 col-xl-8">
            <h6 class="control-section-title">Filtrar</h6>
            <div class="row g-3 align-items-end">
              <div class="col-12 col-md-5">
                <label class="form-label">Desde</label>
                <input type="date" class="form-control" [(ngModel)]="fechaInicio">
              </div>
              <div class="col-12 col-md-5">
                <label class="form-label">Hasta</label>
                <input type="date" class="form-control" [(ngModel)]="fechaFin">
              </div>
              <div class="col-12 col-md-2">
                <button class="btn btn-secondary w-100" (click)="aplicarFiltros()">
                  <i class="fe fe-filter me-1"></i> Aplicar
                </button>
              </div>
            </div>
          </div>

          <div class="col-12 col-xl-4 control-actions-section">
            <h6 class="control-section-title">Acciones</h6>
            <div class="row g-2">
              <div class="col-12 col-sm-6">
                <button class="btn btn-success w-100" (click)="exportarExcel()" [disabled]="spinnerBoolean">
                  <i class="fe fe-download me-1"></i> Exportar Excel
                </button>
              </div>
              <div class="col-12 col-sm-6">
                <button class="btn btn-primary w-100" routerLink="/sistema/crear-paquete">
                  <i class="fe fe-plus me-1"></i> Crear Paquete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Tabla -->
<div class="row row-sm">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="table-responsive">
          <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                 class="table table-bordered table-striped table-hover dt-ext mobile-friendly-table documentos-table">
            <thead>
              <tr>
                <th style="min-width: 40px;">#</th>
                <th style="min-width: 100px;">Secuencial</th>
                <th style="min-width: 120px;">Beneficiario</th>
                <th style="min-width: 90px;">Total</th>
                <th style="min-width: 80px;">N° Orden</th>
                <th style="min-width: 100px;">Cédula</th>
                <th style="min-width: 90px;">Forma Pago</th>
                <th style="min-width: 80px; font-size: 0.85rem;">Fecha</th>
                <th style="min-width: 50px; font-size: 0.75rem; padding: 0.25rem !important;">Firmado</th>
                <th style="min-width: 50px; font-size: 0.75rem; padding: 0.25rem !important;">Enviado</th>
                <th style="min-width: 60px; font-size: 0.75rem; padding: 0.25rem !important;">Autorizado</th>
                <th style="min-width: 70px; font-size: 0.75rem; padding: 0.25rem !important;">Enviado Cliente</th>
                <th style="min-width: 100px;">Facturador</th>
                <th style="min-width: 100px;">Estado</th>
                <th style="min-width: 90px;">Nota Crédito</th>
                <th style="min-width: 80px;">Acciones</th>
              </tr>
            </thead>
            <tbody>
              @for (d of documentos; track d.COD_TRAC; let i = $index) {
                <tr>
                  <td>{{ i + 1 }}</td>
                  <td><span class="badge bg-primary">{{ d.NUM_TRAC || d.NUM_TRACFIC }}</span></td>
                  <td>{{ d.nombre_cliente?.trim() ? d.nombre_cliente : d.NOM_CLI }}</td>
                  <td><strong>$ {{ d.TOTPAG_TRAC }}</strong></td>
                  <td>{{ d.ordenFactura === 'multiple' ? 'PAQUETE' : d.ordenFactura }}</td>
                  <td>{{ d.CED_CLI }}</td>
                  <td>{{ d.METPAG_TRAC }}</td>
                  <td>{{ formatFecha(d.FEC_TRAC) }}</td>
                  <td class="text-center" style="padding: 0.25rem !important; vertical-align: middle;">
                    @if (shouldShowCheck('firmado', d)) {
                      <i class="fe fe-check" style="color: #28a745; font-size: 14px;"></i>
                    }
                  </td>
                  <td class="text-center" style="padding: 0.25rem !important; vertical-align: middle;">
                    @if (shouldShowCheck('enviado', d)) {
                      <i class="fe fe-check" style="color: #28a745; font-size: 14px;"></i>
                    }
                  </td>
                  <td class="text-center" style="padding: 0.25rem !important; vertical-align: middle;">
                    @if (shouldShowCheck('autorizado', d)) {
                      <i class="fe fe-check" style="color: #28a745; font-size: 14px;"></i>
                    }
                  </td>
                  <td class="text-center" style="padding: 0.25rem !important; vertical-align: middle;">
                    @if (shouldShowCheck('enviadoCliente', d)) {
                      <i class="fe fe-check" style="color: #28a745; font-size: 14px;"></i>
                    }
                  </td>
                  <td>{{ d.nombre_usuario }}</td>
                  <td>
                    <span [ngClass]="'badge ' + getEstadoBadgeClass(d.estadoFactura)">
                      {{ getEstadoLabel(d.estadoFactura) }}
                    </span>
                  </td>
                  <td>
                    <span [ngClass]="getNotaCreditoBadgeClass(d.estadoNota)">
                      {{ d.estadoNota ? 'SI' : 'NO' }}
                    </span>
                  </td>
                  <td class="text-center" style="min-width: 80px;">
                    <div ngbDropdown container="body">
                      <button class="btn btn-sm btn-primary" ngbDropdownToggle type="button" title="Opciones">
                        <i class="fe fe-settings"></i>
                      </button>
                      <div ngbDropdownMenu>
                        <a ngbDropdownItem href="javascript:;" (click)="generarRide(d)">
                          <i class="zmdi zmdi-collection-pdf text-danger"></i> Ver RIDE
                        </a>
                        <a ngbDropdownItem href="javascript:;" (click)="abrirDocumentoTabla(d)">
                          <i class="zmdi zmdi-collection-pdf text-danger"></i> Ticket
                        </a>
                        @if (puedeEnviarSRI(d)) {
                          <a ngbDropdownItem href="javascript:;" (click)="enviarDocumentoSRI(d)" [class.disabled]="estaEnviandoSRI(d)">
                            @if (estaEnviandoSRI(d)) {
                              <span class="spinner-border spinner-border-sm text-success me-1"></span> Enviando...
                            } @else {
                              <i class="fe fe-send text-success"></i> Enviar al SRI
                            }
                          </a>
                        }
                        @if (!d.estadoNota && d.NOM_CLI !== 'CONSUMIDOR FINAL') {
                          <a ngbDropdownItem href="javascript:;" (click)="abrirModalNotaCredito(d)">
                            <i class="fe fe-file-plus text-warning"></i> Nota Crédito
                          </a>
                        }
                      </div>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
